import styled from 'styled-components';
import SendIcon from '@material-ui/icons/Send';

const ButtonSendIcon = styled(SendIcon)`
  margin-left: 10px;
`;

export default ButtonSendIcon;
